import { render, staticRenderFns } from "./reference.vue?vue&type=template&id=9895ebea&scoped=true"
import script from "./reference.vue?vue&type=script&lang=js"
export * from "./reference.vue?vue&type=script&lang=js"
import style0 from "./reference.vue?vue&type=style&index=0&id=9895ebea&prod&lang=less&scoped=true"
import style1 from "./reference.vue?vue&type=style&index=1&id=9895ebea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9895ebea",
  null
  
)

export default component.exports